// Packages
import { createSlice } from '@reduxjs/toolkit';
// Redux
import { getTardyReportAsync } from './tardyReportThunk';
import { clearReducer } from '../auth/authThunk';
// Interfaces and types
import { IErrorRes } from 'types/appTypes';
import { IGetTardyReportRes } from 'types/tardyReportTypes';

interface ISliceTardyReportState {
  tardyReport: IGetTardyReportRes | null;
  error: IErrorRes | null;
  isLoading: boolean;
}

const initialState: ISliceTardyReportState = {
  tardyReport: null,
  error: null,
  isLoading: false,
};

const tardyReport = createSlice({
  name: 'tardyReport',
  initialState,
  reducers: {
    clearErrors: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    //* GET TARDY REPORT ASYNC THUNK
    builder.addCase(getTardyReportAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getTardyReportAsync.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.tardyReport = payload;
    });
    builder.addCase(getTardyReportAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* CLEAR REDUCER AFTER SIGN OUT
    builder.addCase(clearReducer, () => initialState);
  },
});

export default tardyReport;
